<template>
    <div class="media-container" :class="mediaDisplayModeClass" :style="mediaDisplayModeVars">
        <GetMediaContent  :section="section" :placeholder-image="placeholderImage" />
        <GetMediaCaption :caption="section.media.caption" />
    </div>
</template>
<script>
import GetMediaContent from "@/scripts/view/portfolio/sections/_helper/GetMediaContent.vue";
import GetMediaCaption from "@/scripts/view/portfolio/sections/_helper/GetMediaCaption.vue";
import {SectionModuleTypeEnum} from "@/scripts/common/enums.js";
import {SectionTypesEnum} from "@/scripts/common/enums.js";

export default {
    name: "Media",
    props: {
        section: Object,
        placeholderImage: {
            String,
            default: 'empty-big-image.jpg'
        }
    },
    components: {
        GetMediaContent,
        GetMediaCaption
    },
    computed: {
        mediaDisplayModeClass() {
            if (this.section?.type !== SectionTypesEnum.HERO) {
                return null;
            }
            return this.section?.media?.displayMode || null;
        },
        mediaDisplayModeVars() {
            if (this.section?.type !== SectionTypesEnum.HERO) {
                return null;
            }
            const displayMode = this.section?.media?.displayMode;
            if (!displayMode) return null;
            const match = displayMode.match(/^frame_offset_(\d+)$/);
            if (!match) return null;
            return { '--imgFrameOffset': `${match[1]}px` };
        },
    },
}
</script>